import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { ReactComponent as Image } from '../../../../../assets/images/cv/check-in-eye-gradient.svg';
import { setRegStep } from '../../../../../graphql';
import { CvModalBase } from '../cv-modal-base';
import { CvSuccessStepProps } from './cv-registration-success.models';

export const CvRegistrationSuccess = ({ onNavigate, ...props }: CvSuccessStepProps): JSX.Element => {

  useEffect((): void => {
    setRegStep(2);
  }, [setRegStep]);

  return (
    <CvModalBase
      {...props}
      title={<FormattedMessage id="appointmentRegistration.appointmentSuccessStep.title.cv" />}
      text="appointmentRegistration.appointmentSuccessStep.description"
      button="appointmentRegistration.appointmentSuccessStep.nextButton.label"
      buttonTestId="cv-success-button"
      onAction={onNavigate}
      image={<Image aria-hidden="true" />}
    />
  );
};
